<template>
    <div class="gameListBox" @scroll="move($event)">
        <div>
            <div class="padding">
                <gameli v-for="game in gameList" :key='game.id' :game="game" :isdown='isdown'></gameli>
            </div>
            <p class="loadtexts" v-show="moreflag">没有更多的数据了</p>
        </div>
        
        <p class="loadtext" v-show="flag">正在加载</p>
        
    </div>
</template>
<script>
import gameli from '@/components/gamebox/gamelist';
import { androidMethod } from '@/utils/base';
export default {
    data(){
        return {
            uuid:'',
            gameList:[],
            page:1,
            flag: false,
            moreflag:false,
            isdown:true
        }
    },
    created(){
        let search = window.location.search.substring(1).split('&')
        this.tagId = search[0].split('=')[1]
        this.uuid = '963af46a328d43349ab3ab296d208283';
        // this.uuid = JSON.parse(androidMethod('getUserInfo','')).uuId
        this.getlist()
    },
    components:{
        gameli
    },
    mounted(){
        //下载的状态；0下载；1进行中；2暂停；3打开
        //进入页面就会调用的方法
        window['AndroidLifeOnResume'] = () => {
            for(var i = 0;i<this.gameList.length;i++){
                if(androidMethod('isGameInstall',"",this.gameList[i].packageName)){
                    this.gameList[i].btntext = '打开'
                    this.gameList[i].loadstate = 3
                }else{
                    var status = localStorage.getItem('statusarr')
                    this.gameList[i].loadstate = localStorage.getItem('statusarr') ? status[i] : 0
                    if(this.gameList[i].loadstate == 2){
                        this.gameList[i].btntext = '暂停'
                    }else{
                        this.gameList[i].btntext = '下载'
                        this.gameList[i].loadstate = 0
                    }
                }
            }
        }
        //下载失败
        window['DownloadFailed'] = (pkg) => {
            for(var i = 0;i<this.gameList.length;i++){//
                if(pkg == this.gameList[i].packageName){
                    this.gameList[i].btntext = '下载';
                    this.gameList[i].loadstate = 0;
                }
            }
        }
        //下载成功
        window['DownloadSuccess'] = (pkg) => {
            for(var i = 0;i<this.gameList.length;i++){//
                if(pkg == this.gameList[i].packageName){
                    this.gameList[i].btntext = '打开';
                    this.gameList[i].loadstate = 3;
                }
            }
        }
        //下载暂停
        window['DownloadInterrupt'] = (pkg) => {
            for(var i = 0;i<this.gameList.length;i++){//
                if(pkg == this.gameList[i].packageName){
                    this.gameList[i].btntext = '暂停';
                    this.gameList[i].loadstate = 2;
                }
            }
        }
        //下载进度的回调
        window['DownloadProgress'] = (pkg, progress) => {//包名，游戏id,状态 pkg, gid, progress
            for(var i = 0;i<this.gameList.length;i++){//
                if(pkg == this.gameList[i].packageName){
                    var num = progress*100
                    this.gameList[i].btntext = num.toFixed(2) + '%'
                    this.gameList[i].loadstate = 1;
                }
            }
        }
    },
    methods:{
        getlist(){
            // this.$http.post('http://easymock.233wei.cn/mock/5e3919a47967af073af3f84a/qTLN2Nec/Frontend/Classify/V2/Games#!method=POST&queryParameters=%5B%5D&body=&headers=%5B%5D').then((res) => {
            //     var data = res.data;
            //     if(data.return_code == 200){
            //         this.moreflag = data.isEnd;
            //         if(!this.moreflag){
            //             data.data.games.forEach(element => {
            //                 element.loadstate = 0;
            //                 element.btntext = '下载';
            //                 this.gameList.push(element)
            //             });
            //         }
            //         //判断是否加载完成
            //         this.flag = false;
            //     }
            // })
            this.$http.post(`/apiserv/qTLN2Nec/Frontend/Classify/V2/Games?uuid=${this.uuid}&sortType=1&tags=${this.tagId},31&pageIndex=${this.page}&pageSize=20`).then(res => {
                var data = res.data;
                if(data.return_code == 200){
                    this.moreflag = data.isEnd;
                    if(!this.moreflag){
                        data.data.games.forEach(element => {
                            element.loadstate = 0;
                            element.btntext = '下载';
                            this.gameList.push(element)
                        });
                    }
                    //判断是否加载完成
                    this.flag = false;
                }     
            })
            
        },
        move(event){
            this.$nextTick(() =>{
                var scrollH = event.target.scrollHeight;
                var scrollT = event.target.scrollTop;
                var screenH = window.screen.height;  // 屏幕可视高度
                if (scrollH - scrollT == screenH){ //5只是一个相对值，可以让页面再接近底面的时候就开始请求
                    this.flag = !this.moreflag ? true : false;
                    this.page++;
                    this.getlist()
                }
            }) 
        },
        changebtn(game){
            for(var i=0;i<this.gameList.length;i++){
                if(game.packageName == this.gameList[i].packageName){
                    if(game.loadstate ==0 || game.loadstate == 2){
                        androidMethod('downloadGame',"",JSON.stringify(game));
                    }else if(game.loadstate ==1){
                        androidMethod('downloadStop',"",JSON.stringify(game));
                    }else{
                        androidMethod('playGame',"",game.packageName);
                    }
                }
            }
           
        }
    }
}
</script>
<style lang="less" scoped>
.gameListBox{
    color: #999;
    font-size: 0.13rem;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
}
.padding{
    padding: 0 0.166rem 0 0.166rem;
}
.loadtext{
    width: 100%;
    height: 30px;
    line-height: 30px;
    background: #ccc;
    color: gray;
    text-align: center;
    position: absolute;
    bottom: 0;
    left: 0;
}
.loadtexts{
    width: 100%;
    height: 30px;
    line-height: 30px;
    background: #ccc;
    color: gray;
    text-align: center;
}
</style>